import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { LazyImage } from 'components/common/Image';
import { constructMSAImageUrl } from 'helpers';

const RELATED_STYLE_IMG_SRC_PARAMS = { autoCrop: true, height: 100 };

const SwatchImage = ({ imageId, thumbnailImageId, msaImageId, styleColor, productSeoUrl, styleId, setImageId, onClick }) => {
  const msaId = imageId || thumbnailImageId || msaImageId || null;
  const imgSrc = constructMSAImageUrl(msaId, RELATED_STYLE_IMG_SRC_PARAMS);
  let linkEvents = null;

  if (setImageId) {
    linkEvents = {
      onMouseEnter: () => setImageId(msaId),
      onMouseLeave: () => setImageId(null),
      onFocus: () => setImageId(msaId),
      onBlur: () => setImageId(null)
    };
  }

  return (
    <li key={styleId}>
      <Link
        to={productSeoUrl}
        onClick={onClick}
        {...linkEvents}>
        <LazyImage src={imgSrc} alt={`Color ${styleColor}`} />
      </Link>
    </li>
  );
};

SwatchImage.propTypes = {
  onClick: PropTypes.func
};

export default SwatchImage;
